<script setup lang="ts">
import { BaseAvatar, BaseBadge, BaseIcon } from '@magma-app/magma-lapilli';

import RewardRetrievalTimeline from '@/components/rewards/RewardRetrievalTimeline.vue';

import type { ManageRewardsItem } from './types';

defineProps<{
  item: ManageRewardsItem;
  contactEmail?: string | null;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
  (event: 'contact-admin'): void;
}>();
</script>

<template>
  <div>
    <div class="mb-2 border-b border-border-subtle px-8 py-4 md:mb-4">
      <div class="mb-4 flex justify-between">
        <BaseAvatar
          :src="!item.pictureUrl ? '/img/reward_lg.png' : item.pictureUrl"
          size="xl"
          shape="rounded"
        />

        <div class="ml-4 flex-1 truncate">
          <h3
            class="truncate text-mgm-txt-lg font-medium text-foreground-emphasis"
          >
            {{ item.name }}
          </h3>

          <BaseBadge
            class="mt-2"
            size="md"
            color="grey"
            :text="item.points"
            icon-type="icon"
            icon-name="star"
          />
        </div>

        <BaseIcon
          class="ml-2"
          icon="close"
          color="#5F6C85"
          hover-state
          @click="emit('close')"
        />
      </div>

      <p
        class="scrollbar-hide mt-4 max-h-28 overflow-scroll text-mgm-txt-sm font-normal text-foreground-default"
        v-html="item.description"
      ></p>
    </div>

    <RewardRetrievalTimeline
      :status="item.status"
      :retrieval-instruction="item.retrievalInstruction"
      :contact-email="contactEmail"
      @contact-admin="emit('contact-admin')"
    />
  </div>
</template>
